const minusIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="16" y="9" width="2" height="12" transform="rotate(90 16 9)" fill="white"/>
</svg>                
`;

export default minusIcon;
